"use strict";
import {on,  findAllIn, trigger, findAll, findIn, find, closest} from '@elements/dom-utils';
import {onFind, initInScope} from "@elements/init-modules-in-scope";
import asyncAppend from "@elements/async-append";
import axios from "axios";

export function init() {
    onFind('.js-color-change', function (element) {
        let form = findIn('.js-color-change__form', element);

        initInputs(element);

        if(form) {
            on('change', function (evt) {
                loadContent(element, form.getAttribute('data-action'), new FormData(form))
            }, form);
        }

    });

    onFind('.js-product-grid--color-change', function (element) {
        on('product-grid.changed', (evt) => {
            let form = find('.js-color-change__form');

            if (form) {
                if (findAllIn('.js-color-change__input input[type="radio"]', element)) {
                    findAllIn('.js-color-change__input input[type="radio"]', element).map((item) => {
                        let targetInput = findIn('input[name="' + item.name + '"][value="'+ item.value +'"]', form);
                        if (targetInput) {
                            targetInput.checked = item.checked;
                        }
                    });
                }

                trigger('change', form);
            }
        }, element);
    });
}


export function loadContent(container, url, data, method) {
    let pendingRequest;

    pendingRequest = axios({method: 'POST', url: url, data: data });

    asyncAppend({
        target: findAllIn('.js-color-change__content', container),
        loading: findAllIn('.js-color-change__loading', container)
    }, pendingRequest.then((x) => {
        if (x.data.success && x.data.htmlForm) {
            findIn('.js-color-change__form', container).innerHTML = x.data.htmlForm;

            initInScope(findIn('.js-color-change__form', container));
            initInputs(container);
        }

        return x.data;
    }));

    return pendingRequest;
}

function initInputs(element){
    findAllIn('.js-color-change__input input[type="radio"]', element).map((input) => {
        on('click', () => {
            findAll('.js-color-change').map((item) => {
                let targetInput = findIn('input[name="' + input.name + '"][value="'+ input.value +'"]', item)

                if (item !== element) {
                    if (findIn('input[type="radio"]:checked', item) !== targetInput) {
                        targetInput.checked = true;
                        trigger('change', targetInput);
                    }
                }
            });
        }, input);
    });
}